export const SEARCH_LEVEL_OPTIONS = [
  { key: "ACCOUNT", label: "Account" },
  { key: "TEAM", label: "Company" },
  { key: "GLOBAL", label: "Global" },
];
